import axios from "axios";
import { getDeviceInfo } from "../utils/editorUtils/editorUtils";
export const moduleApiEndPoint = "https://contentapi-edetail-gilead.indegene.com/api/v1/";
export const unifiedPageUrl = "https://contentstudio.gilead.com/";

//const moduleApiEndPoint = "https://cida-api-dev.indegene.com/api/v1/";
export const PreviewEndPoint = "https://contentapi-edetail-gilead.indegene.com/";


export const instance = axios.create({
  baseURL: moduleApiEndPoint,
  timeout: 120000,
});

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    //  const token = "12345678dkdklsdf";
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
      config.headers["device-info"] = getDeviceInfo();
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
export const instanceStorage = axios.create({
  baseURL: moduleApiEndPoint,
  timeout: 8000,
  // headers: { "X-Custom-Header": "foobar" },
});

// Add a request interceptor
instanceStorage.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    //  const token = "12345678dkdklsdf";
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instanceStorage.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const instanceUpload = axios.create({
  baseURL: moduleApiEndPoint,
  timeout: 60 * 4 * 1000,
  headers: {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
});

// Add a request interceptor
instanceUpload.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    //  const token = "12345678dkdklsdf";
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instanceStorage.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// export default instance;

export default instance;
